import { useEffect, useState } from 'react';
import { Box, Fade, Typography } from '@mui/material';

const PINK = '#ff3aa3';

export function SplashScreen({ duration = 6000, onFinish }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <Fade
      in={show}
      timeout={{ enter: 0, exit: 700 }}
      appear={false}
      unmountOnExit
      onExited={onFinish}
    >
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 2000,
          bgcolor: '#000',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: 3, md: 4 },
          overflow: 'hidden',
          '@keyframes suhZoomOut': {
            from: { transform: 'scale(1.6)' },
            to: { transform: 'scale(1)' },
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: { xs: 3, md: 4 },
            transformOrigin: 'center center',
            animation: `suhZoomOut ${duration}ms ease-out forwards`,
          }}
        >
          <Box
            component="img"
            src={`${process.env.PUBLIC_URL}/suh-logo-pink.svg`}
            alt="Suh Pelada"
            sx={{ width: { xs: '80vw', md: '55vw' }, maxWidth: 720, height: 'auto' }}
          />
          <Typography
            sx={{
              fontFamily: 'monospace',
              fontWeight: 700,
              color: PINK,
              fontSize: { xs: '2rem', md: '3.5rem' },
              letterSpacing: '.4rem',
            }}
          >
            Suh Pelada
          </Typography>
        </Box>
      </Box>
    </Fade>
  );
}
